import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { AuthShell, Field } from "./AuthShell";
import { Input } from "@/components/ui/input";
import { PasswordInput } from "@/components/common/PasswordInput";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const data = await login(email, password);
      toast.success("Welcome back!");
      const r = data.user.role;
      navigate(r === "super_admin" ? "/admin" : r === "staff" ? "/staff" : "/dashboard");
    } catch (err) {
      toast.error(apiError(err, "Could not sign in"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell
      title="Sign in"
      subtitle="Access your Smart Menu dashboard."
      footer={<>New here? <Link to="/register" className="font-semibold text-emerald-600 hover:underline">Create a restaurant</Link></>}
    >
      <form onSubmit={submit} className="space-y-4" data-testid="login-form">
        <Field label="Email">
          <Input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@restaurant.com" />
        </Field>
        <Field label="Password">
          <PasswordInput data-testid="login-password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" />
        </Field>
        <div className="flex justify-end">
          <Link to="/forgot-password" className="text-sm font-medium text-emerald-600 hover:underline">Forgot password?</Link>
        </div>
        <Button data-testid="login-submit" type="submit" disabled={busy} className="w-full bg-emerald-500 hover:bg-emerald-600">
          {busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Sign in
        </Button>
      </form>
    </AuthShell>
  );
}
